export class ProjectedPerformance {
  public cashOnCashRate: number;
  public cashOnCashRateMax: number;

  public nonLeveragedCapRate: number;
  public nonLeveragedCapRateMax: number;

  public targetInvestmentIrr: number;
  public targetInvestmentIrrMax: number;

  public expectedRoi: number;
  public expectedRoiMax: number;

  public targetEquityMultiplier: number;
  public targetEquityMultiplierMax: number;

  public targetInvestmentPeriod: number;
  public targetInvestmentPeriodMax: number;

  public targetInvestmentPeriodMonths: number;
  public targetInvestmentPeriodMonthsMax: number;

  public preferredReturn: number;
  public preferredReturnMax: number;
}
